import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
export const FinalCTA: React.FC = () => {
  const handlePurchase = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  return <section className="py-20 px-4 bg-blue-900 text-center" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-66">
          Dejá de perder tiempo armando entrenamientos que no funcionan
        </h2>

        <p className="text-xl text-blue-200 mb-10" data-id="element-67">
          Elegí el pack completo, descargá los 7 productos y empezá a aplicar
          desde mañana.
        </p>

        <div className="flex justify-center mb-8" data-id="element-68">
          <CountdownTimer variant="light" data-id="element-69" />
        </div>

        <button onClick={handlePurchase} className="bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 px-10 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.5)] hover:shadow-[0_0_30px_rgba(34,197,94,0.7)] transition-all animate-pulse-fast" data-id="element-70">
          Quiero el pack completo — $
          {CONSTANTS.PRICING.SALE.toLocaleString('es-AR')}
        </button>
      </div>
    </section>;
};